import { motion } from "framer-motion";

/**
 * Masked line-by-line reveal.
 * Each line renders inside an overflow-hidden container and slides up from y:110% to 0
 * with stagger. Text splits on \n.
 */
export default function RevealText({ text, className = "", delay = 0.1, stagger = 0.12, as: Tag = "h1" }) {
  const lines = text.split("\n");
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line" style={{ display: "block", overflow: "hidden" }}>
          <motion.span
            style={{ display: "block", willChange: "transform" }}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              delay: delay + i * stagger,
              duration: 1.1,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
